var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _line, _path22, _circle, _line2, _path23, _line3, _path24, _line4, _path25, _path26, _path27, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon10, _polygon11, _polygon12, _polygon13, _polygon14, _polygon15, _polygon16, _polygon17, _polygon18;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSage20LogoSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1653.4 510.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-1,.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9,.cls-10,.cls-11,.cls-12,.cls-13,.cls-14,.cls-15,.cls-16,.cls-17{stroke-width:0px;}.cls-2{fill:url(#New_Gradient_Swatch_copy-3);}.cls-3{fill:url(#New_Gradient_Swatch_copy);}.cls-4{fill:url(#linear-gradient-6);}.cls-5{fill:#77a7c9;}.cls-6{fill:#c6c4c4;}.cls-7{fill:url(#New_Gradient_Swatch_copy-5);}.cls-8{fill:#0185b2;}.cls-9{fill:url(#linear-gradient-5);}.cls-10{fill:#999;}.cls-11{fill:url(#linear-gradient-2);}.cls-12{fill:url(#New_Gradient_Swatch_copy-2);}.cls-13{fill:url(#New_Gradient_Swatch_copy-4);}.cls-14{fill:url(#New_Gradient_Swatch_copy-6);}.cls-15{fill:url(#linear-gradient-3);}.cls-18{fill:none;stroke:#231f20;stroke-miterlimit:10;stroke-width:4.5px;}.cls-16{fill:#231f20;}.cls-17{fill:url(#linear-gradient-4);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy",
    x1: 551.49,
    y1: 109.44,
    x2: 551.49,
    y2: 274.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#0085b2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0e1e3a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 567.95,
    y1: 109.44,
    x2: 567.95,
    y2: 274.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#006990"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0e142a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy-2",
    x1: 691.76,
    y1: 204.63,
    x2: 691.76,
    xlinkHref: "#New_Gradient_Swatch_copy"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 708.22,
    y1: 204.63,
    x2: 708.22,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy-3",
    x1: 726.82,
    y1: 188.76,
    x2: 726.82,
    xlinkHref: "#New_Gradient_Swatch_copy"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 743.29,
    y1: 188.76,
    x2: 743.29,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy-4",
    x1: 656.69,
    y1: 172.89,
    x2: 656.69,
    xlinkHref: "#New_Gradient_Swatch_copy"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 673.15,
    y1: 172.89,
    x2: 673.15,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy-5",
    x1: 586.55,
    y1: 157.02,
    x2: 586.55,
    xlinkHref: "#New_Gradient_Swatch_copy"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 603.02,
    y1: 157.02,
    x2: 603.02,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy-6",
    x1: 621.62,
    y1: 142.05,
    x2: 621.62,
    xlinkHref: "#New_Gradient_Swatch_copy"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 638.09,
    y1: 142.05,
    x2: 638.09,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M91.29,78.61c29.74,0,45.02,17.79,45.02,48.91v6.11h-28.9v-8.06c0-13.9-5.56-19.18-15.28-19.18s-15.29,5.28-15.29,19.18,6.11,24.73,26.12,42.24c25.57,22.51,33.63,38.63,33.63,60.86,0,31.13-15.56,48.91-45.58,48.91s-45.58-17.79-45.58-48.91v-11.95h28.9v13.9c0,13.9,6.11,18.9,15.84,18.9s15.84-5,15.84-18.9-6.11-24.73-26.12-42.24c-25.57-22.51-33.63-38.63-33.63-60.86,0-31.13,15.28-48.91,45.02-48.91Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M253.04,275.37h-30.85l-5.28-35.29h-37.52l-5.28,35.29h-28.07l31.13-194.54h44.74l31.13,194.54ZM183.28,213.67h29.46l-14.45-98.38h-.56l-14.45,98.38Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M312.79,166.98h42.8v61.7c0,31.13-15.56,48.91-45.58,48.91s-45.58-17.79-45.58-48.91v-101.16c0-31.13,15.56-48.91,45.58-48.91s45.58,17.79,45.58,48.91v18.9h-28.9v-20.84c0-13.9-6.11-19.18-15.84-19.18s-15.84,5.28-15.84,19.18v105.05c0,13.9,6.11,18.9,15.84,18.9s15.84-5,15.84-18.9v-35.85h-13.9v-27.79Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M405.9,162.81h41.97v27.79h-41.97v56.97h52.8v27.79h-83.37V80.83h83.37v27.79h-52.8v54.19Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1459.12,415.13c8.72-12.42,11.55-21.36,11.55-31.17,0-25.07-19.18-43.37-44.9-43.37-18.09,0-28.33,7.85-34.44,14.82-5.67,6.54-10.24,15.47-10.9,30.08h16.13c.22-7.41,1.96-12.86,4.79-17.22,5.45-8.28,13.95-12.86,24.19-12.86,17.22,0,28.99,11.99,28.99,28.33,0,5.88-1.53,12.86-8.06,22.23-3.49,5.23-13.29,16.78-17,21.14l-52.96,61.24h93.94v-14.82h-61.46l30.3-34.22c5.88-6.76,13.73-15.69,19.83-24.19Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1497.92,468.74c-5.88,0-10.9,5.01-10.9,10.9s5.01,10.9,10.9,10.9,10.9-5.01,10.9-10.9-5.01-10.9-10.9-10.9Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1605.59,362.38c-11.12-16.13-25.72-21.8-37.27-21.8s-26.16,5.67-37.27,21.8c-9.59,13.95-14.6,32.69-14.6,53.4s5.01,39.45,14.6,53.4c11.12,16.13,25.72,21.79,37.27,21.79s26.15-5.67,37.27-21.79c9.59-13.95,14.6-32.69,14.6-53.4s-5.01-39.45-14.6-53.4ZM1593.38,460.03c-7.63,12.2-17.65,16.13-25.06,16.13s-17.44-3.92-25.07-16.13c-7.85-12.42-10.68-28.99-10.68-44.24s2.83-31.82,10.68-44.24c7.63-12.21,17.65-16.13,25.07-16.13s17.44,3.92,25.06,16.13c7.85,12.42,10.68,28.99,10.68,44.24s-2.83,31.82-10.68,44.24Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M45.43,296.02h94.49v27.79h-31.96v166.75h-30.57v-166.75h-31.96v-27.79Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M217.18,490.56c-1.67-5-2.78-8.06-2.78-23.9v-30.57c0-18.06-6.11-24.73-20.01-24.73h-10.56v79.2h-30.57v-194.54h46.13c31.68,0,45.3,14.73,45.3,44.74v15.28c0,20.01-6.39,32.79-20.01,39.19v.56c15.28,6.39,20.29,20.84,20.29,41.13v30.01c0,9.45.28,16.4,3.34,23.62h-31.13ZM183.83,323.81v59.75h11.95c11.39,0,18.34-5,18.34-20.57v-19.18c0-13.89-4.73-20.01-15.56-20.01h-14.73Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M363.92,490.56h-30.85l-5.28-35.3h-37.52l-5.28,35.3h-28.07l31.13-194.54h44.74l31.13,194.54ZM294.17,428.86h29.46l-14.45-98.38h-.56l-14.45,98.38Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M405.89,349.66h-.56v140.9h-27.51v-194.54h38.35l30.85,116.44h.56v-116.44h27.24v194.54h-31.4l-37.52-140.9Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M537.9,293.8c29.74,0,45.02,17.79,45.02,48.91v6.11h-28.9v-8.06c0-13.9-5.56-19.18-15.29-19.18s-15.28,5.28-15.28,19.18,6.11,24.73,26.12,42.24c25.57,22.51,33.63,38.63,33.63,60.86,0,31.13-15.56,48.91-45.58,48.91s-45.58-17.79-45.58-48.91v-11.95h28.9v13.9c0,13.9,6.11,18.9,15.84,18.9s15.84-5,15.84-18.9-6.11-24.73-26.12-42.24c-25.57-22.51-33.63-38.63-33.63-60.86,0-31.13,15.29-48.91,45.02-48.91Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M691.31,344.1v25.29c0,31.13-15.01,48.08-45.58,48.08h-14.45v73.09h-30.57v-194.54h45.02c30.57,0,45.58,16.95,45.58,48.08ZM631.28,323.81v65.87h14.45c9.73,0,15.01-4.45,15.01-18.34v-29.18c0-13.9-5.28-18.34-15.01-18.34h-14.45Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M800.81,490.56h-30.85l-5.28-35.3h-37.52l-5.28,35.3h-28.07l31.13-194.54h44.74l31.13,194.54ZM731.06,428.86h29.46l-14.45-98.38h-.56l-14.45,98.38Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M878.91,490.56c-1.67-5-2.78-8.06-2.78-23.9v-30.57c0-18.06-6.11-24.73-20.01-24.73h-10.56v79.2h-30.57v-194.54h46.13c31.68,0,45.3,14.73,45.3,44.74v15.28c0,20.01-6.39,32.79-20.01,39.19v.56c15.29,6.39,20.29,20.84,20.29,41.13v30.01c0,9.45.28,16.4,3.33,23.62h-31.13ZM845.56,323.81v59.75h11.95c11.39,0,18.34-5,18.34-20.57v-19.18c0-13.89-4.72-20.01-15.56-20.01h-14.73Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M957.29,378.01h41.97v27.79h-41.97v56.97h52.8v27.79h-83.37v-194.54h83.37v27.79h-52.8v54.19Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M1056.78,349.66h-.56v140.9h-27.51v-194.54h38.35l30.85,116.44h.56v-116.44h27.24v194.54h-31.4l-37.52-140.9Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M1236.31,418.03v25.85c0,31.13-15.56,48.91-45.58,48.91s-45.58-17.79-45.58-48.91v-101.16c0-31.13,15.56-48.91,45.58-48.91s45.58,17.79,45.58,48.91v18.9h-28.9v-20.84c0-13.9-6.11-19.18-15.84-19.18s-15.84,5.28-15.84,19.18v105.05c0,13.9,6.11,18.9,15.84,18.9s15.84-5,15.84-18.9v-27.79h28.9Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M1280.51,426.09l-38.63-130.06h31.96l23.07,88.65h.56l23.07-88.65h29.18l-38.63,130.06v64.48h-30.57v-64.48Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1061.5,199.79l-201.41-17.65-3.86,9-38.74-4.45c1.29-38.72-10.58-78.07-36.55-110.68-57.99-72.84-164.44-84.93-237.28-26.93-68.84,54.8-83.4,152.88-35.85,224.97h34.46c-1.37-1.57-2.71-3.17-4.03-4.82-48.55-60.98-38.43-150.09,22.54-198.63,60.98-48.55,150.09-38.43,198.63,22.55,43.12,54.16,39.96,130.5-4,180.91h34.44c11.38-17.32,19.32-36.41,23.71-56.22l38.99,5.03,1.33,8.59,202.1,34.09c18.94-28.12,5.52-65.75,5.52-65.75Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M758.46,139.09c3.59,7.31,6.59,14.97,9.03,22.91.57,1.99,1.19,3.99,1.73,6.01l1.52,6.11,1.32,6.21c.37,2.09.74,4.19,1.19,6.31,2.86-16.99.9-34.94-4.91-51.63-5.83-16.71-15.6-32.18-28.23-44.79-12.62-12.62-28.08-22.39-44.79-28.22-16.69-5.8-34.64-7.77-51.63-4.93,2.12.44,4.22.81,6.31,1.18l6.21,1.32,6.11,1.52c2.02.54,4.01,1.16,6.01,1.72,7.94,2.44,15.6,5.43,22.91,9.03,14.64,7.15,27.89,16.62,39.26,27.98,11.35,11.38,20.82,24.64,27.97,39.27Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 579.2,
    y1: 88.61,
    x2: 616.39,
    y2: 119.25
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M574.14,95.41c-3.61-2.97-4.12-8.3-1.15-11.91s8.3-4.12,11.91-1.15c3.61,2.97,4.12,8.3,1.15,11.91-2.97,3.61-8.3,4.12-11.91,1.15Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-16",
    cx: 616.07,
    cy: 118.98,
    r: 8.46,
    transform: "translate(-1.01 232.6) rotate(-21.36)"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 665.72,
    y1: 107.73,
    x2: 703.83,
    y2: 166.16
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M696.51,170.42c2.55,3.91,7.79,5.02,11.71,2.46,3.91-2.55,5.02-7.79,2.46-11.71-2.55-3.91-7.79-5.02-11.71-2.46-3.91,2.55-5.02,7.79-2.46,11.71Z"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 703.04,
    y1: 164.95,
    x2: 737.96,
    y2: 156.76
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M739.48,165.09c4.55-1.07,7.37-5.62,6.31-10.17-1.07-4.55-5.62-7.37-10.17-6.31-4.55,1.07-7.37,5.62-6.31,10.17,1.07,4.55,5.62,7.37,10.17,6.31Z"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 616.01,
    y1: 118.94,
    x2: 664.03,
    y2: 108.11
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M665.48,116.46c4.56-1.03,7.42-5.56,6.39-10.11-1.03-4.56-5.56-7.42-10.11-6.39-4.56,1.03-7.42,5.56-6.39,10.11,1.03,4.56,5.56,7.42,10.11,6.39Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M508.78,162.55l-27.27-3.46c-5.17,39.18,3.3,80.12,26.29,114.98h34.46c-1.37-1.57-2.71-3.17-4.03-4.82-24.89-31.26-34.35-69.91-29.46-106.7Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M789.09,198.14c-3.33,27.56-14.7,54.16-33.68,75.93h34.44c11.38-17.32,19.32-36.41,23.71-56.22l38.99,5.03,1.33,8.59,202.1,34.09c6.91-10.25,9.5-21.76,10.02-32.26l-276.92-35.16Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "559.71 274.99 543.26 268.15 543.26 109.44 559.71 116.29 559.71 274.99"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "559.71 274.99 576.19 268.15 576.19 109.44 559.71 116.29 559.71 274.99"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "699.98 197.78 683.53 204.63 699.98 211.51 716.46 204.63 699.98 197.78"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "699.98 274.99 683.53 268.15 683.53 204.63 699.98 211.51 699.98 274.99"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "699.98 274.99 716.46 268.15 716.46 204.63 699.98 211.51 699.98 274.99"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "735.05 181.91 718.6 188.76 735.05 195.64 751.53 188.76 735.05 181.91"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "735.05 274.99 718.6 268.15 718.6 188.76 735.05 195.64 735.05 274.99"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "735.05 274.99 751.53 268.15 751.53 188.76 735.05 195.64 735.05 274.99"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "664.91 166.04 648.46 172.89 664.91 179.77 681.39 172.89 664.91 166.04"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "664.91 274.99 648.46 268.15 648.46 172.89 664.91 179.77 664.91 274.99"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "664.91 274.99 681.39 268.15 681.39 172.89 664.91 179.77 664.91 274.99"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "594.78 150.17 578.33 157.02 594.78 163.9 611.26 157.02 594.78 150.17"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "594.78 274.99 578.33 268.15 578.33 157.02 594.78 163.9 594.78 274.99"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "594.78 274.99 611.26 268.15 611.26 157.02 594.78 163.9 594.78 274.99"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "629.84 135.25 613.4 142.05 629.84 148.88 646.33 142.05 629.84 135.25"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "629.84 274.99 613.4 268.19 613.4 142.05 629.84 148.88 629.84 274.99"
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "629.84 274.99 646.33 268.19 646.33 142.05 629.84 148.88 629.84 274.99"
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "559.69 102.58 543.24 109.42 559.69 116.3 576.17 109.42 559.69 102.58"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSage20LogoSvg);
export default __webpack_public_path__ + "static/media/Sage2.0-logo-svg.d55ca693160792f22a2b28ff6a181005.svg";
export { ForwardRef as ReactComponent };